import {
  number,
  object,
  string,
  boolean,
  array,
  enum as a,
  union,
  literal,
} from 'zod';

export const schemaGeneralData = object({
  consultant: number().nonnegative({
    message: 'Consultante inválido ou não encontrado.',
  }),
  professional: number().nonnegative({
    message: 'Profissional inválido ou não encontrado.',
  }),
  specialty: number().nonnegative({
    message: 'Especialidade inválida ou não encontrada',
  }),
  type: number().nonnegative({
    message: 'Tipo de atendimento inválido',
  }),
});

export const schemaDateHours = object({
  date: string().nonempty({ message: 'Data inválida' }),
  hourStart: string().nonempty({ message: 'Hora de ínicio incorreta' }),
  hourEnd: string().nonempty({ message: 'Hora final incorreta' }),
});

export const schemaEditConsult = object({
  consultant: number().nonnegative({
    message: 'Consultante inválido ou não encontrado.',
  }),
  professional: number().nonnegative({
    message: 'Profissional inválido ou não encontrado.',
  }),
  specialty: number().nonnegative({
    message: 'Especialidade inválida ou não encontrada',
  }),
  date: string().nonempty({ message: 'Data inválida' }),
  hourStart: string().nonempty({ message: 'Hora de ínicio incorreta' }),
  hourEnd: string().nonempty({ message: 'Hora final incorreta' }),
  service: string().optional(),
  type: number().nonnegative({
    message: 'Tipo de atendimento inválido',
  }),
  serviceArea: number().nonnegative({
    message: 'Selecione a área de atendimento',
  }),
  title: string().max(128).optional(),
  healthUnit: number().nonnegative().optional(),
});

export const schemaGuest = object({
  email: union([string().email(), literal('')]),
  name: string()
    .max(128)
    .nonempty({ message: 'Insira seu nome completo.' })
    .optional(),
});

export const schema = object({
  appointmentId: number().nonnegative(),
  professional: number().nonnegative().optional(),
  specialty: number().nonnegative().optional(),
  consultant: number().nonnegative().optional(),
  organizer: number().nonnegative().optional(),
  healthPlan: number().nonnegative().optional(),
  healthUnit: number().nonnegative().optional(),
  obs: string().optional(),
  status: a(['CANCELED', 'ENDED']).optional(),
  priority: a([
    'REGULAR',
    'ELDERLY',
    'PREGNANT',
    'NURSINGMOTHER',
    'INFANT',
    'CHILDREN_UP_TO_5',
    'EMERGENCY',
  ]).optional(),
  type: number().nonnegative().optional(),
  allowInvite: boolean().optional(),
  date: string().optional(),
  duration: number().optional(),
  note: string().nonempty().optional(),
  companions: array(
    object({
      id: number().nonnegative().optional(),
      name: string().optional(),
      phone: string(),
      email: string(),
      role: a([
        'GRANDPARENT',
        'PARENT',
        'SPOUSE',
        'SIBLING',
        'SON',
        'RELATIVE',
        'FRIEND',
        'OTHER',
      ]),
    }),
  ).optional(),
  professionals: array(
    object({
      id: number().nonnegative().optional(),
      name: string().optional(),
      phone: string(),
      email: string(),
      specialty: string(),
    }),
  ).optional(),
  title: string().max(128).optional(),
}).refine(data => {
  if (
    (data.professional || data.specialty) &&
    (!data.professional || !data.specialty)
  )
    return false;
  return true;
});

export const schemaUpdateSidebar = object({
  fullNameConsultant: string().optional(),
  fullNameProfessional: string().optional(),
  dnv: string().optional(),
  unit: string().optional(),
  regValue: string().optional(),
  professionalRegValue: string().optional(),
  regType: string().optional(),
  clinicalCondition: string()
    .max(4096, 'Você atingiu o limite de 4096 caracteres para este campo.')
    .optional(),
  forwarding: string()
    .max(4096, 'Você atingiu o limite de 4096 caracteres para este campo.')
    .optional(),
});
